import createIcon from '../../createIcon';

/**
 * @component @name ForwardToInbox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAyLjVIMy41QzIuNCAyLjUgMS41IDMuNCAxLjUgNC41VjE2LjVDMS41IDE3LjYgMi40IDE4LjUgMy41IDE4LjVIMTIuNVYxNi41SDMuNVY2LjVMMTEuNSAxMS41TDE5LjUgNi41VjExLjVIMjEuNVY0LjVDMjEuNSAzLjQgMjAuNiAyLjUgMTkuNSAyLjVaTTExLjUgOS41TDMuNSA0LjVIMTkuNUwxMS41IDkuNVpNMTguNSAxMy41TDIyLjUgMTcuNUwxOC41IDIxLjVWMTguNUgxNC41VjE2LjVIMTguNVYxMy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ForwardToInbox = createIcon('ForwardToInbox', [
  [
    'path',
    {
      d: 'M19.5 2.5H3.5C2.4 2.5 1.5 3.4 1.5 4.5V16.5C1.5 17.6 2.4 18.5 3.5 18.5H12.5V16.5H3.5V6.5L11.5 11.5L19.5 6.5V11.5H21.5V4.5C21.5 3.4 20.6 2.5 19.5 2.5ZM11.5 9.5L3.5 4.5H19.5L11.5 9.5ZM18.5 13.5L22.5 17.5L18.5 21.5V18.5H14.5V16.5H18.5V13.5Z',
      key: 'h6tq86',
    },
  ],
]);

export default ForwardToInbox;
